/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid2, Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import IconWithImage from 'components/IconWithImage';
import UserSvg from '/public/icons/user.svg?icon';
import ComputerSvg from '/public/icons/computer.svg?icon';
import SailLogo from '/public/images/home/homeTwo.svg';

const ICON_SX: SxProps<Theme> = {
  color: '#000',
  fontSize: '32px',
};

const Features = (): JSX.Element => {
  const t = useTranslations('Home');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Grid2
      container
      spacing={2}
      direction={isMd ? 'row' : 'column-reverse'}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        my: {
          xs: 2,
          md: 8,
        },
      }}
    >
      <Grid2
        data-aos={isMd ? 'fade-right' : 'fade-up'}
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Box
          sx={{
            fontSize: {
              xs: '32px',
              md: '40px',
            },
            fontWeight: 700,
          }}
        >
          {t('advantages')}
        </Box>
        <Box
          sx={{
            color: '#000',
            fontSize: {
              xs: '16px',
              md: '20px',
            },
            my: 3,
          }}
        >
          {t('advantagesDescription')}
        </Box>
        <Grid2
          display={'flex'}
          alignItems="center"
          justifyContent="space-between"
          size={12}
          container
          spacing={2}
        >
          <Grid2 size={6}>
            <IconWithImage
              title={t('employeesTitle')}
              icon={UserSvg}
              iconSx={ICON_SX}
              boxSx={{
                background: '#E7EEFF',
                width: '100%',
                cursor: 'pointer',
                padding: {
                  xs: '12px',
                  md: '24px',
                },
              }}
              typographySx={{
                fontSize: {
                  xs: '16px',
                  md: '20px',
                },
                fontWeight: 500,
                height: '42px',
              }}
              footerIconSx={{
                color: 'inherit',
                fill: 'currentcolor',
                fontSize: '32px',
              }}
              href={'/book-demo'}
            />
          </Grid2>
          <Grid2 size={6}>
            <IconWithImage
              title={t('contractorsTitle')}
              icon={ComputerSvg}
              iconSx={ICON_SX}
              boxSx={{
                background: '#E7EEFF',
                width: '100%',
                cursor: 'pointer',
                padding: {
                  xs: '12px',
                  md: '24px',
                },
              }}
              typographySx={{
                fontSize: {
                  xs: '16px',
                  md: '20px',
                },
                fontWeight: 500,
                height: '42px',
              }}
              footerIconSx={{
                color: 'inherit',
                fill: 'currentcolor',
                fontSize: '32px',
              }}
              href={'/book-demo'}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        data-aos={isMd ? 'fade-left' : 'fade-up'}
        container
        justifyContent="center"
        alignItems="center"
        size={6}
        sx={{
          display: { xs: 'none', md: 'flex' },
        }}
      >
        <Box border="none">
          <Image
            alt="sailglobal logo"
            src={SailLogo}
            width={420}
            height={330}
            style={{
              maxHeight: '100%',
              maxWidth: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default Features;
